var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 8.75C7.4908 8.75 8.75 7.4908 8.75 5.9375C8.75 4.3842 7.4908 3.125 5.9375 3.125C4.3842 3.125 3.125 4.3842 3.125 5.9375C3.125 7.4908 4.3842 8.75 5.9375 8.75Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 8.75C15.6158 8.75 16.875 7.4908 16.875 5.9375C16.875 4.3842 15.6158 3.125 14.0625 3.125C12.5092 3.125 11.25 4.3842 11.25 5.9375C11.25 7.4908 12.5092 8.75 14.0625 8.75Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 16.875C7.4908 16.875 8.75 15.6158 8.75 14.0625C8.75 12.5092 7.4908 11.25 5.9375 11.25C4.3842 11.25 3.125 12.5092 3.125 14.0625C3.125 15.6158 4.3842 16.875 5.9375 16.875Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 16.875C15.6158 16.875 16.875 15.6158 16.875 14.0625C16.875 12.5092 15.6158 11.25 14.0625 11.25C12.5092 11.25 11.25 12.5092 11.25 14.0625C11.25 15.6158 12.5092 16.875 14.0625 16.875Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFour);
export default __webpack_public_path__ + "static/media/circle-four.5cfe8394039d3c9505fdde93687d020c.svg";
export { ForwardRef as ReactComponent };